import React from 'react';
import { View } from 'react-native';
import { PlayerManager } from '@24i/react-native-player';
import baseStyles, { timelineStyle } from './styles';
// import { Timeline } from '../../../Player/PlatformPlayerUI';

interface MiniPlayerProgressBarProps {
    playerInstance: PlayerManager;
}

const MiniPlayerProgressBar = ({
    playerInstance
}: MiniPlayerProgressBarProps): React.ReactElement => (
    <View style={baseStyles.container}>
        {/* <Timeline
            key="timeline"
            // player-base and playerInstance are the same
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            playerInstance={playerInstance}
            styles={timelineStyle}
        /> */}
    </View>
);

export default MiniPlayerProgressBar;
